import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICheckoutSteps } from "./checkoutSteps.interfaces";

const initialState: ICheckoutSteps = {
  shouldRevalidate: true,
  currentStep: 0,
  allStepsAreValid: false,
  steps: {
    brandedFares: {
      valid: true,
      expanded: false,
      disabled: true,
    },
    contactInformation: {
      valid: false,
      expanded: false,
      disabled: true,
    },
    travelerInformation: {
      valid: false,
      expanded: false,
      disabled: true,
    },
    additionalProducts: {
      valid: false,
      expanded: false,
      disabled: true,
    },
    paymentMethod: {
      valid: false,
      expanded: false,
      disabled: true,
    },
  },
};

export const checkoutStepsSlice = createSlice({
  name: "checkoutSteps",
  initialState,
  reducers: {
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    setIsValid: (
      state,
      action: PayloadAction<{ key: string; valid: boolean }>,
    ) => {
      const objectKey = action.payload.key as keyof typeof state.steps;
      state.steps[objectKey].valid = action.payload.valid;

      // Set all valid state
      const invalidStepsArray = Object.values(state.steps).filter(
        (step) => !step.valid,
      );
      state.allStepsAreValid = invalidStepsArray.length == 0;
    },
    setIsDisabled: (
      state,
      action: PayloadAction<{ key: string; disabled: boolean }>,
    ) => {
      const objectKey = action.payload.key;

      state.steps[objectKey as keyof typeof state.steps].disabled =
        action.payload.disabled;
    },
    setIsExpanded: (
      state,
      action: PayloadAction<{
        key: string;
        expanded: boolean;
      }>,
    ) => {
      const objectKey = action.payload.key;
      state.steps[objectKey as keyof typeof state.steps].expanded =
        action.payload.expanded;
    },

    setShouldRevalidate: (state, action: PayloadAction<boolean>) => {
      state.shouldRevalidate = action.payload;
    },

    goToStep: (state, action: PayloadAction<number>) => {
      if (action.payload > 0) {
        const previousKey = Object.keys(state.steps)[action.payload - 1];
        const previousObjectKey = previousKey as keyof typeof state.steps;

        state.steps[previousObjectKey].expanded = false;
        state.steps[previousObjectKey].valid = true;
      }

      const newKey = Object.keys(state.steps)[action.payload];
      const newObjectKey = newKey as keyof typeof state.steps;

      state.steps[newObjectKey].expanded = true;
      state.steps[newObjectKey].disabled = false;

      state.currentStep = action.payload;
    },
    resetCheckoutSteps: (state) => {
      state.currentStep = 0;
      state.allStepsAreValid = false;
      state.steps = {
        ...initialState.steps,
      };
    },
    setCheckoutSlice: (state, action: PayloadAction<ICheckoutSteps>) => {
      return action.payload;
    },
  },
});

export const {
  setCurrentStep,
  setIsDisabled,
  setIsValid,
  setIsExpanded,
  goToStep,
  resetCheckoutSteps,
  setShouldRevalidate,
  setCheckoutSlice,
} = checkoutStepsSlice.actions;
